<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(document).ready(function(){
      $('.template-product [data-toggle]').on('click', function(e){
        e.preventDefault();
        let popName = $(this).data("target");
        $('.modal-backdrop').addClass('show');
        $(popName).addClass('show');
        $('body').toggleClass("modal-open");
      });
      // close modal on clicking close button
      $('.modal-content').find('.close').on('click',function(){
        $(this).parents('.halo_modal-custom').removeClass('show');
        $('.modal-backdrop').removeClass('show');
        $('body').toggleClass("modal-open");
      
      });
      var widgetTitleSlt = "[data-has-collapse] .widget-title";
      var sidebarLabelDesktop = ".sidebar-label-desktop";
      var viewMore = "[data-list-filter]";

      $('body')
        .off("click.toggleWidgetContent")
        .on("click.toggleWidgetContent", widgetTitleSlt, function () {
          $(this).toggleClass("open");
          $(this).next().toggle();
          $(this).closest('.sidebar-tags').siblings().children('.widget-title').removeClass('open');
        });

      var widgetTitleSltCollNoSidebar =
        "[data-has-collapse-no-sidebar] .widget-title";
      var wrapper = $(".toolbar");

  // for stop the css in menu 
  // if ($('.dspg-page-return-test')){
  //    $('.has-megamenu').hover(function() {
  //   $(this).find('.menu-dropdown').attr('style','visibility: visible; opacity: 1 !important');
  // },function(){
  //   $(this).find('.menu-dropdown').attr('style','visibility: hidden; opacity: 0 !important');
  // });

  // }
 
});